window.duo.studyScriptingScope = (node, name, value) => ({
    node,
    name,
    value,

    /**
     * Checks whether the value is empty
     */
    empty(value) {
        return ! value || value.length === 0;
    },

    /**
     * Check whether the value if not empty
     */
    notEmpty(value) {
        return ! this.empty(value);
    },

    /**
     * Gets the node for an element identifier
     */
    get(element) {
        if (! element) return null;

        let node = element;
        if (typeof node === 'string') {
            node = document.getElementById(element);
            if (! node) node = document.querySelector(`[name="${ element }"]`);
            if (! node) node = document.querySelector(`[name="${ element }[]"]`);
            if (! node) return null;
        }

        return node;
    },

    /**
     * Gets the base element
     */
    getBase(element) {
        const node = this.get(element);
        if (! node) return null;

        const base = node.closest('[data-id="base-element"]');
        if (! base) return null;

        return base;
    },

    /**
     * Get the node list of all items for that element
     */
    getItems(element) {
        const parent = this.get(element);
        if (! parent) return new NodeList();

        if (this.isSelect(parent)) {
            return parent.querySelectorAll('option');
        }

        if (this.isCheckItem(parent) || this.isRadioItem(parent)) {
            const base = this.getBase(parent);
            if (! base) return new NodeList();

            return base.querySelectorAll(`[name="${ parent.name }"]`);
        }

        return new NodeList();
    },

    /**
     * Gets the node for an item in an element
     */
    getItem(element, itemId) {
        const parent = this.get(element);
        if (! parent) return null;

        const items = Array.from(this.getItems(parent) || []);

        if (this.isSelect(parent) || this.isCheckItem(parent) || this.isRadioItem(parent)) {
            return items.find(i => i.value === itemId) || null;
        }

        return null;
    },

    /**
     * Gets the value of a given element
     */
    valueOf(element) {
        const node = this.get(element);
        if (! node) return;

        return window.duo.fieldValue(node);
    },

    /**
     * Hides an entire element
     */
    hide(element) {
        const base = this.getBase(element);
        if (! base) return;

        base.classList.add('d-none');
    },

    /**
     * Shows an entire element
     */
    show(element) {
        const base = this.getBase(element);
        if (! base) return;

        base.classList.remove('d-none');
    },

    /**
     * Toggles an entire element
     */
    toggle(element, condition = null) {
        const base = this.getBase(element);
        if (! base) return;

        if (condition === null) {
            base.classList.contains('d-none')
                ? base.classList.remove('d-none')
                : base.classList.add('d-none');

            return;
        }

        base.classList[condition ? 'remove' : 'add']('d-none');
    },

    /**
     * Hides an option from a given element
     */
    hideItem(element, itemId) {
        const node = this.getItem(element, itemId);
        if (! node) return;

        const toggleNode = this.isCheckItem(node) || this.isRadioItem(node)
            ? node.parentElement
            : node;

        toggleNode.classList.add('d-none');
    },

    /**
     * Shows an option from a given element
     */
    showItem(element, itemId) {
        const node = this.getItem(element, itemId);
        if (! node) return;

        const toggleNode = this.isCheckItem(node) || this.isRadioItem(node)
            ? node.parentElement
            : node;

        toggleNode.classList.remove('d-none');
    },

    /**
     * Hides an option from a given element
     */
    toggleItem(element, itemId, condition = null) {
        const node = this.getItem(element, itemId);
        if (! node) return;

        const toggleNode = this.isCheckItem(node) || this.isRadioItem(node)
            ? node.parentElement
            : node;

        if (condition === null) {
            toggleNode.classList.contains('d-none')
                ? toggleNode.classList.remove('d-none')
                : toggleNode.classList.add('d-none');

            return;
        }

        toggleNode.classList[condition ? 'remove' : 'add']('d-none');
    },

    /**
     * Checks whether the element is a select element
     */
    isSelect(element) {
        const node = this.get(element);
        if (! node) return false;

        return node.tagName === 'SELECT';
    },

    /**
     * Checks whether the element is a check item
     */
    isCheckItem(element) {
        const node = this.get(element);
        if (! node) return false;

        return node.tagName === 'INPUT' && (node.type === 'checkbox' || node.name.endsWith('[]'));
    },

    /**
     * Checks whether the element is a radio item
     */
    isRadioItem(element) {
        const node = this.get(element);
        if (! node) return false;

        return node.tagName === 'INPUT' && node.type === 'radio';
    }
});
